export const adsScript: any = {
  "/": {
    homeSobeysApp: {
      id: "div-gpt-ad-1747629323892-22",
      slotPath: "/22966717622/foodlands_get_foodlands_app_dxp",
      sizes: ["fluid"],
      addSize: [],
    },
    homeBanner1: {
      id: "div-gpt-ad-1747629444319-22",
      slotPath: "/22966717622/foodlands_home_carousel_1",
      sizes: ["fluid"],
      addSize: [],
    },
    homeBanner2: {
      id: "div-gpt-ad-1749299294229-22",
      slotPath: "/22966717622/foodlands_home_carousel_2",
      sizes: ["fluid"],
      addSize: [],
    },
    homeBanner3: {
      id: "div-gpt-ad-1749299374502-22",
      slotPath: "/22966717622/foodlands_home_carousel_3",
      sizes: ["fluid"],
      addSize: [],
    },
    AdCard: {
      id: `div-gpt-ad-1745921120713-22`,
      slotPath: `/22966717622/foodlands_dxp_708x464`,
      sizes: [[708, 464]],
      addSize: [
        [
          [1024, 0],
          [708, 464],
        ],
      ],
    },
    leaderboard_B: {
      id: `div-gpt-ad-6196258-1`,
      slotPath: `/22966717622/foodlands_homepage_top_728x90-320x50_dxp`,
      sizes: [
        [728, 90],
        [320, 50],
      ],
      addSize: [
        [
          [1024, 0],
          [728, 90],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [200, 0],
          [270, 50],
        ],
      ],
    },
    leaderboard_A: {
      id: "div-gpt-ad-1739264297477-22",
      slotPath: "/22966717622/foodlands_native_970x250_template_dxp",
      sizes: ["fluid"],
      addSize: [],
    },
    homepagecard_1: {
      id: `div-gpt-ad-1753702685567-22`,
      slotPath: `/22966717622/foodlands_homepage_bottom_342x285_dxp_1`,
      sizes: ["fluid"],
      addSize: [],
    },
      homepagecard_2: {
      id: `div-gpt-ad-1753702830597-22`,
      slotPath: `22966717622/foodlands_homepage_bottom_342x285_dxp_2`,
      sizes: ["fluid"],
      addSize: [],
    },
    // bottom: {
    //   id: `div-gpt-ad-1737547032087-22`,
    //   slotPath: `/22966717622/foodlands_homepage_bottom_464x410_dxp1`,
    //   sizes: [[464, 410]],
    //   addSize: [
    //     [
    //       [1024, 0],
    //       [464, 410],
    //     ],
    //     [
    //       [768, 0],
    //       [342, 285],
    //     ],
    //     [
    //       [768, 0],
    //       [212, 176],
    //     ],
    //   ],
    // },
    // foodlands_homepage_bottom_728x90: {
    //   id: `div-gpt-ad-1738153158850-22`,
    //   slotPath: `/22966717622/foodlands_homepage_bottom_728x90-320x50_dxp`,
    //   sizes: [
    //     [320, 50],
    //     [728, 90],
    //     [270, 90],
    //   ],
    //   addSize: [
    //     [
    //       [1024, 0],
    //       [728, 90],
    //     ],
    //     [
    //       [768, 0],
    //       [728, 90],
    //     ],
    //     [
    //       [350, 0],
    //       [320, 50],
    //     ],
    //     [
    //       [100, 0],
    //       [270, 50],
    //     ],
    //   ],
    // },
    // Middle_mobile: {
    //   id: `div-gpt-ad-1738155006102-22`,
    //   slotPath: `/22966717622/foodlands_homepage_mobile-middle_432x362_dxp`,
    //   sizes: [[432, 362]],
    //   addSize: [
    //     [
    //       [300, 0],
    //       [432, 362],
    //     ],
    //   ],
    // },
  },
  "/recipes": {
    leaderboardTop_A: {
      id: `div-gpt-ad-1738647053957-22`,
      slotPath: `/22966717622/foodlands_recipe-page_leaderboard_970x250_dxp`,
      sizes: [
        [728, 90],
        [970, 250],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1310, 0],
          [970, 250],
        ],
      ],
    },
    rectangleMiddle_A: {
      id: `div-gpt-ad-1737550439749-22`,
      slotPath: `/22966717622/foodlands_recipe-page_middle_220x194_dxp`,
      sizes: [[220, 194]],
      addSize: [],
    },
    leaderboardBottom_A: {
      id: `div-gpt-ad-1738647551904-22`,
      slotPath: `/22966717622/foodlands_recipe-page_bottom_970x250_dxp`,
      sizes: [
        [970, 250],
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1310, 0],
          [970, 250],
        ],
      ],
    },
    leaderboardTop_B: {
      id: `div-gpt-ad-1738647696473-22`,
      slotPath: `/22966717622/foodlands_recipe-page_leaderboard_728x90_dxp`,
      sizes: [
        [
          [320, 50],
          [728, 90],
          [270, 50],
        ],
      ],
      addSize: [
        [
          [1200, 0],
          [728, 90],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
    rectangleMiddle_B: {
      id: `div-gpt-ad-1738647790876-22`,
      slotPath: `/22966717622/foodlands_recipe-page_middle_160x600_dxp`,
      sizes: [[160, 600]],
      addSize: [],
    },
    leaderboardBottom_B: {
      id: `div-gpt-ad-1738735654046-22`,
      slotPath: `/22966717622/foodlands_recipe-page_bottom_728x90_dxp`,
      sizes: [
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [728, 90],
        ],
      ],
    },
  },
  "/products": {
    leaderboardTop_A: {
      id: `div-gpt-ad-1738567971789-22`,
      slotPath: `/22966717622/foodlands_product-category_billboard_970x250_dxp`,
      sizes: [
        [970, 250],
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1310, 0],
          [970, 250],
        ],
      ],
    },
    rectangleMiddle_A: {
      id: `div-gpt-ad-1737547287714-22`,
      slotPath: `/22966717622/foodlands_product-category_middle_220x194_dxp`,
      sizes: [[220, 194]],
      addSize: [],
    },
    leaderboardBottom_A: {
      id: `div-gpt-ad-1738608761954-22`,
      slotPath: `/22966717622/foodlands_product-category_bottom_728x90_dxp`,
      sizes: [
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
    leaderboardTop_B: {
      id: `div-gpt-ad-1738568281014-22`,
      slotPath: `/22966717622/foodlands_product-category_billboard_728x90_dxp`,
      sizes: [
        [
          [728, 90],
          [320, 50],
          [270, 50],
        ],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [728, 90],
        ],
      ],
    },
    rectangleMiddle_B: {
      id: `div-gpt-ad-1738608665198-22`,
      slotPath: `/22966717622/foodlands_product-category_middle_160x600_dxp`,
      sizes: [[160, 600]],
      addSize: [],
    },
  },
  "/recipes/[slug]": {
    leaderboardBottom: {
      id: `div-gpt-ad-1738643861308-22`,
      slotPath: `/22966717622/foodlands_receipe-detail_bottom_728x90_dxp`,
      sizes: [
        [320, 50],
        [728, 90],
        [270, 50],
      ],
      addSize: [
        [
          [1024, 0],
          [728, 90],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
  },
  "/products/[slug]": {
    leaderboardTop: {
      id: `div-gpt-ad-1737547623605-22`,
      slotPath: `/22966717622/foodlands_product-detail_leaderboard_728x90_dxp`,
      sizes: [[728, 90]],
      addSize: [],
    },
    leaderboardBottom: {
      id: `div-gpt-ad-1737548317430-22`,
      slotPath: `/22966717622/foodlands_product-detail_below-image_464x58_dxp`,
      sizes: [[464, 58]],
      addSize: [],
    },
  },
  "/flyer": {
    leaderboardTop_A: {
      id: `div-gpt-ad-1738641056630-22`,
      slotPath: `/22966717622/foodlands_flyer-page_top_970x250`,
      sizes: [
        [320, 50],
        [728, 90],
        [970, 250],
        [270, 50],
      ],
      addSize: [
        [
          [1200, 0],
          [970, 250],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
    leaderboardBottom_A: {
      id: `div-gpt-ad-1738735738078-22`,
      slotPath: `/22966717622/foodlands_flyer-page_bottom_970x250`,
      sizes: [
        [320, 50],
        [728, 90],
        [970, 250],
        [270, 50],
      ],
      addSize: [
        [
          [1200, 0],
          [970, 250],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
  },
  "/flyer/product": {
    leaderboardTop_A: {
      id: `div-gpt-ad-1738641995878-22`,
      slotPath: `/22966717622/foodlands_flyer-product-page_top_728x90`,
      sizes: [
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
      ],
    },
    rectangleMiddle_A: {
      id: `div-gpt-ad-1738642075167-22`,
      slotPath: `/22966717622/foodlands_flyer-product-page_middle_160x600`,
      sizes: [[160, 600]],
      addSize: [],
    },
    leaderboardBottom_A: {
      id: `div-gpt-ad-1738642239088-22`,
      slotPath: `/22966717622/foodlands_flyer-product-page_bottom_728x90`,
      sizes: [
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
      ],
    },
    leaderboardTop_B: {
      id: `div-gpt-ad-1738642377691-22`,
      slotPath: `/22966717622/foodlands_flyer-product-page_top_970x250`,
      sizes: [
        [
          [970, 250],
          [320, 50],
          [728, 90],
          [270, 50],
        ],
      ],
      addSize: [
        [
          [1280, 0],
          [970, 250],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
    leaderboardBottom_B: {
      id: `div-gpt-ad-1738642814070-22`,
      slotPath: `/22966717622/foodlands_flyer-product-page_bottom_970x250`,
      sizes: [
        [970, 250],
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1280, 0],
          [970, 250],
        ],
      ],
    },
  },
  "/search": {
    leaderboardTop_A: {
      id: `search-page-top`,
      slotPath: `/22966717622/foodlands_native_970x250_template_dxp_search`,
      sizes: ["fluid"],
      addSize: [],
    },
    // rectangleMiddle_A: {
    //   id: `div-gpt-ad-1737550439749-22`,
    //   slotPath: `/22966717622/foodlands_recipe-page_middle_220x194_dxp`,
    //   sizes: [[220, 194]],
    //   addSize: [],
    // },
    leaderboardBottom_A: {
      id: `div-gpt-ad-1738640713531-22`,
      slotPath: `/22966717622/foodlands_search-result_bottom_728x90_dxp`,
      sizes: [
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [728, 90],
        ],
      ],
    },
    leaderboardTop_B: {
      id: `fdsfsfdsfs`,
      slotPath: `/22966717622/foodlands_native_728x90_template_dxp`,
      sizes: ["fluid"],
      addSize: [],
    },
    leaderboardBottom_B: {
      id: `div-gpt-ad-1738640799130-22`,
      slotPath: `/22966717622/foodlands_recipe-page_bottom_728x90_dxp`,
      sizes: [
        [728, 90],
        [320, 50],
        [970, 250],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [970, 250],
        ],
      ],
    },
    rectangleMiddle_B: {
      id: `div-gpt-ad-1738640168528-22`,
      slotPath: `/22966717622/foodlands_search-result_middle_160x600_dxp`,
      sizes: [[160, 600]],
      addSize: [],
    },
    leaderboardTop_C: {
      id: `div-gpt-ad-1738640662989-22`,
      slotPath: `/22966717622/foodlands_search-result_top_728x90_dxp`,
      sizes: [
        [320, 50],
        [728, 90],
        [270, 50],
      ],
      addSize: [
        [
          [1024, 0],
          [728, 90],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [100, 0],
          [270, 50],
        ],
      ],
    },
    leaderboardBottom_C: {
      id: `div-gpt-ad-1738640844589-22`,
      slotPath: `/22966717622/foodlands_search-result_bottom_728x90_dxp_C`,
      sizes: [
        [320, 50],
        [728, 90],
      ],
      addSize: [
        [
          [320, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [728, 90],
        ],
      ],
    },
  },
  "/articles/[slug]": {
    leaderboardBottom: {
      id: `div-gpt-ad-1738643662045-22`,
      slotPath: `/22966717622/foodlands_article_bottom_728x90`,
      sizes: [
        [
          [320, 50],
          [728, 90],
        ],
      ],
      addSize: [
        [
          [300, 0],
          [270, 50],
        ],
        [
          [360, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [728, 90],
        ],
      ],
    },
  },
};